import { mapFiles, getFiles } from 'utils/mapFiles';

export default mapFiles(getFiles(require.context('./', true, /.ts/)));
